/* Current storefront data stays in the page; only recipe and variant IDs enter session storage. */
(() => {
  'use strict';
  const root = document.querySelector('[data-bfc-compare-catalog]');
  const dialog = document.getElementById('bfc-compare-dialog');
  if (!root || !dialog || typeof dialog.showModal !== 'function' || window.bfcCompareReady) return;
  let recipes;
  try { recipes = JSON.parse(root.dataset.products); } catch { return; }
  if (!Array.isArray(recipes)) return;
  const catalog = new Map(recipes.filter(recipe => recipe && /^\d+$/.test(recipe.id) && Array.isArray(recipe.variants) && recipe.variants.length).map(recipe => [recipe.id, recipe]));
  if (!catalog.size) return;
  window.bfcCompareReady = true;
  const storageKey = 'babafuchs.recipe-comparison.v1';
  const tray = document.querySelector('[data-bfc-compare-tray]');
  const tableHost = dialog.querySelector('[data-bfc-compare-table]');
  const picker = dialog.querySelector('[data-bfc-compare-picker]');
  const addSelect = dialog.querySelector('[data-bfc-compare-select]');
  const status = dialog.querySelector('[data-bfc-compare-dialog-status]');
  const announcer = document.querySelector('[data-bfc-compare-announcement]');
  let selection = [];
  let opener = null;
  let previousOverflow = '';
  const hasExampleSize = (recipe) => recipe.exampleSize === true;

  const el = (tag, className, text) => {
    const node = document.createElement(tag);
    if (className) node.className = className;
    if (text !== undefined) node.textContent = text;
    return node;
  };
  const textValue = value => typeof value === 'string' && value.trim() ? value : 'Keine Angabe hinterlegt';
  const listValue = value => Array.isArray(value) && value.length ? value.join(' · ') : 'Keine Angabe hinterlegt';
  const publicFact = (recipe, label) => {
    const prefix = `${label}:`;
    const property = Array.isArray(recipe.publicProperties) && recipe.publicProperties.find(value => typeof value === 'string' && value.startsWith(prefix));
    return property ? property.slice(prefix.length).trim() : '';
  };
  const currentVariant = item => catalog.get(item.id).variants.find(variant => variant.id === item.variant) || catalog.get(item.id).variants[0];
  const productURL = (recipe, variant) => {
    const url = new URL(recipe.url, window.location.origin);
    if (url.origin !== window.location.origin) return '#';
    url.searchParams.set('variant', variant.id);
    return url.pathname + url.search;
  };
  const save = () => { try { sessionStorage.setItem(storageKey, JSON.stringify(selection)); } catch { /* Storage is optional. */ } };
  try {
    const stored = JSON.parse(sessionStorage.getItem(storageKey));
    if (Array.isArray(stored)) {
      for (const item of stored) {
        if (!item || typeof item.id !== 'string' || !catalog.has(item.id) || selection.some(entry => entry.id === item.id)) continue;
        const recipe = catalog.get(item.id);
        const variant = recipe.variants.find(entry => entry.id === item.variant) || recipe.variants[0];
        selection.push({ id: item.id, variant: variant.id });
        if (selection.length === 3) break;
      }
    }
  } catch { /* A corrupt or unavailable store starts an empty comparison. */ }

  function announce(message) {
    announcer.textContent = message;
    if (dialog.open) status.textContent = message;
  }

  function syncButtons() {
    document.querySelectorAll('[data-bfc-compare-toggle]').forEach(button => {
      const recipe = catalog.get(button.dataset.bfcCompareToggle);
      if (!recipe) return;
      const selected = selection.some(item => item.id === recipe.id);
      const label = selected ? 'Im Vergleich' : 'Vergleichen';
      button.hidden = false;
      button.setAttribute('aria-pressed', String(selected));
      button.setAttribute('aria-label', `${recipe.title} ${selected ? 'aus dem Vergleich entfernen' : 'zum Vergleich hinzufügen'}`);
      const labelNode = button.querySelector('[data-bfc-compare-toggle-label]');
      if (labelNode && labelNode.textContent !== label) labelNode.textContent = label;
    });
  }

  function syncTray() {
    tray.hidden = selection.length === 0;
    tray.querySelector('[data-bfc-compare-tray-notice]').hidden = true;
    tray.querySelector('[data-bfc-compare-count]').textContent = `${selection.length} von 3 Rezepturen`;
    tray.querySelector('[data-bfc-compare-names]').textContent = selection.map(item => catalog.get(item.id).title).join(' · ');
    tray.querySelector('[data-bfc-compare-open]').textContent = selection.length < 2 ? 'Zweite Rezeptur wählen' : `${selection.length} Rezepturen vergleichen`;
    syncButtons();
  }

  function removeButton(recipe) {
    const button = el('button', 'bfc-compare-remove', 'Entfernen');
    button.type = 'button';
    button.dataset.bfcCompareRemove = recipe.id;
    button.setAttribute('aria-label', `${recipe.title} aus dem Vergleich entfernen`);
    return button;
  }

  function priceCell(item) {
    const recipe = catalog.get(item.id);
    const variant = currentVariant(item);
    const cell = el('div', 'bfc-compare-price');
    cell.dataset.bfcComparePrice = item.id;
    cell.append(el('strong', '', variant.price), el('span', '', variant.unitPrice || 'Grundpreis nicht hinterlegt'));
    cell.append(el('small', '', recipe.comingSoon ? 'Demnächst erhältlich' : recipe.blocked ? 'Noch nicht verfügbar' : variant.available ? 'Verfügbar' : 'Zurzeit ausverkauft'));
    if (hasExampleSize(recipe)) cell.append(el('small', '', 'Grundpreis auf Basis der Beispielgröße. Finale Verkaufsgröße noch nicht bestätigt.'));
    return cell;
  }

  function renderTable() {
    tableHost.replaceChildren();
    const scroller = dialog.querySelector('[data-bfc-compare-table-scroll]');
    scroller.classList.toggle('bfc-compare-table-scroll--empty', selection.length < 2);
    if (selection.length < 2) {
      const empty = el('div', 'bfc-compare-empty');
      empty.append(el('h3', '', selection.length ? 'Eine Rezeptur fehlt noch.' : 'Was möchtest du vergleichen?'));
      empty.append(el('p', '', selection.length ? 'Ergänze eine zweite Rezeptur. Dann siehst du beide direkt nebeneinander.' : 'Wähle oben die erste Rezeptur. Du kannst bis zu drei gegenüberstellen.'));
      selection.forEach(item => {
        const recipe = catalog.get(item.id);
        const chip = el('div', 'bfc-compare-selected');
        chip.append(el('strong', '', recipe.title), removeButton(recipe));
        empty.append(chip);
      });
      tableHost.append(empty);
      return;
    }
    const table = el('table', 'bfc-compare-table');
    table.style.setProperty('--bfc-compare-columns', selection.length);
    const caption = el('caption', 'sr-only', `${selection.length} Rezepturen im Vergleich`);
    const head = el('thead');
    const headingRow = el('tr');
    const corner = el('th', '', 'Dein Vergleich');
    corner.scope = 'col';
    headingRow.append(corner);
    selection.forEach(item => {
      const recipe = catalog.get(item.id);
      const heading = el('th');
      heading.scope = 'col';
      heading.append(el('span', 'bfc-compare-type', recipe.type), el('h3', '', recipe.title), removeButton(recipe));
      headingRow.append(heading);
    });
    head.append(headingRow);
    const body = el('tbody');
    const row = (label, renderCell) => {
      const tr = el('tr');
      const th = el('th', '', label);
      th.scope = 'row';
      tr.append(th);
      selection.forEach(item => {
        const td = el('td');
        const content = renderCell(catalog.get(item.id), item);
        if (typeof content === 'string') td.textContent = content;
        else td.append(content);
        tr.append(td);
      });
      body.append(tr);
    };
    row('Packung', (recipe, item) => {
      const select = el('select', 'bfc-compare-variant');
      select.dataset.bfcCompareVariant = item.id;
      select.setAttribute('aria-label', `Packungsgröße für ${recipe.title}`);
      recipe.variants.forEach(variant => {
        const sizeLabel = variant.title === 'Default Title' ? 'Standardpackung' : variant.title;
        const option = el('option', '', sizeLabel + (hasExampleSize(recipe) ? ' · Beispielgröße' : ''));
        option.value = variant.id;
        option.selected = variant.id === item.variant;
        select.append(option);
      });
      return select;
    });
    row('Preis', (recipe, item) => priceCell(item));
    row('Futterart', recipe => textValue(recipe.type));
    row('Einordnung', recipe => recipe.blocked ? 'Noch nicht freigegeben' : textValue(recipe.designation));
    row('Proteinquellen', recipe => recipe.blocked ? 'Noch nicht freigegeben' : listValue(recipe.proteins));
    row('Merkmale', recipe => recipe.blocked ? 'Noch nicht freigegeben' : listValue(recipe.highlights));
    [['Rohprotein', 'protein'], ['Rohfett', 'fat'], ['Umsetzbare Energie', 'energy']].forEach(([label, key]) => {
      const value = recipe => publicFact(recipe, label) || (key === 'energy' ? recipe.energy : recipe.analysis?.[key]);
      if (selection.some(item => value(catalog.get(item.id)))) row(label, recipe => textValue(value(recipe)));
    });
    row('Zusammensetzung', recipe => {
      if (recipe.blocked) return 'Noch nicht freigegeben';
      if (!Array.isArray(recipe.ingredients) || !recipe.ingredients.length) return 'Keine Angabe hinterlegt';
      const content = el('div', 'bfc-compare-ingredients');
      const makeList = ingredients => {
        const list = el('ul');
        ingredients.forEach(ingredient => {
          const percent = ingredient.percent !== null && ingredient.percent !== undefined && ingredient.percent !== '' ? ` (${String(ingredient.percent).replace('.', ',')} %)` : '';
          list.append(el('li', '', `${ingredient.name || ''}${percent}`));
        });
        return list;
      };
      content.append(makeList(recipe.ingredients.slice(0, 4)));
      if (recipe.ingredients.length > 4) {
        const details = el('details');
        details.append(el('summary', '', `Alle ${recipe.ingredients.length} Zutaten`), makeList(recipe.ingredients.slice(4)));
        content.append(details);
      }
      return content;
    });
    if (selection.some(item => !catalog.get(item.id).blocked)) {
      row('Lebensphase', recipe => recipe.blocked ? 'Noch nicht freigegeben' : textValue(recipe.lifeStage));
      [['Rohfaser', 'fiber'], ['Rohasche', 'ash'], ['Feuchtigkeit', 'moisture'], ['Calcium', 'calcium'], ['Phosphor', 'phosphorus']].forEach(([label, key]) => {
        if (selection.some(item => catalog.get(item.id).analysis?.[key])) row(label, recipe => recipe.blocked ? 'Noch nicht freigegeben' : textValue(recipe.analysis?.[key]));
      });
      row('Fütterung', recipe => recipe.blocked ? 'Noch nicht freigegeben' : textValue(recipe.feeding));
    } else {
      row('Weitere Deklarationsangaben', () => 'Noch nicht freigegeben');
    }
    row('Mehr erfahren', (recipe, item) => {
      const link = el('a', 'bfc-compare-product-link', 'Rezeptur ansehen');
      link.href = productURL(recipe, currentVariant(item));
      link.dataset.bfcCompareProductLink = item.id;
      link.setAttribute('aria-label', `${recipe.title}: Rezeptur ansehen`);
      return link;
    });
    table.append(caption, head, body);
    tableHost.append(table);
  }

  function renderDialog() {
    const previousChoice = addSelect.value;
    addSelect.replaceChildren();
    const candidates = [...catalog.values()].filter(recipe => !selection.some(item => item.id === recipe.id));
    const placeholder = el('option', '', 'Rezeptur auswählen');
    placeholder.value = '';
    addSelect.append(placeholder);
    candidates.forEach(recipe => {
      const option = el('option', '', `${recipe.title} · ${recipe.type}`);
      option.value = recipe.id;
      addSelect.append(option);
    });
    if (candidates.some(recipe => recipe.id === previousChoice)) addSelect.value = previousChoice;
    picker.hidden = selection.length >= 3;
    dialog.querySelector('[data-bfc-compare-add]').disabled = !addSelect.value;
    status.textContent = selection.length >= 2 ? `${selection.length} Rezepturen ausgewählt. Auf kleinen Bildschirmen seitlich wischen, um alle zu sehen.` : `${selection.length} von mindestens 2 Rezepturen ausgewählt.`;
    renderTable();
  }

  function toggle(id, removeOnly = false, preferredVariant = '') {
    if (!catalog.has(id)) return;
    const selected = selection.some(item => item.id === id);
    if (selected) selection = selection.filter(item => item.id !== id);
    else {
      if (removeOnly) return;
      if (selection.length === 3) {
        const message = 'Drei Rezepturen sind ausgewählt. Entferne zuerst eine Rezeptur, um eine andere hinzuzufügen.';
        const notice = tray.querySelector('[data-bfc-compare-tray-notice]');
        notice.hidden = false;
        notice.textContent = message;
        announce(message);
        return;
      }
      const variants = catalog.get(id).variants;
      selection.push({ id, variant: (variants.find(variant => variant.id === preferredVariant) || variants[0]).id });
    }
    save();
    syncTray();
    if (dialog.open) renderDialog();
    announce(`${catalog.get(id).title} ${selected ? 'aus dem Vergleich entfernt' : 'zum Vergleich hinzugefügt'}. ${selection.length} von 3 Rezepturen ausgewählt.`);
  }

  document.addEventListener('click', event => {
    const button = event.target.closest('[data-bfc-compare-toggle], [data-bfc-compare-open], [data-bfc-compare-close], [data-bfc-compare-clear], [data-bfc-compare-add], [data-bfc-compare-remove]');
    if (!button) return;
    event.preventDefault();
    if (button.hasAttribute('data-bfc-compare-toggle')) {
      const currentProductVariant = button.closest('.product-info')?.querySelector('input[name="id"]')?.value;
      toggle(button.dataset.bfcCompareToggle, false, currentProductVariant || button.dataset.bfcCompareInitialVariant);
    }
    else if (button.hasAttribute('data-bfc-compare-open')) {
      if (dialog.open) return;
      opener = button;
      renderDialog();
      previousOverflow = document.body.style.overflow;
      document.body.style.overflow = 'hidden';
      dialog.showModal();
      if (selection.length < 2) addSelect.focus();
    } else if (button.hasAttribute('data-bfc-compare-close')) dialog.close();
    else if (button.hasAttribute('data-bfc-compare-clear')) {
      const firstId = selection[0]?.id;
      selection = [];
      save();
      syncTray();
      announce('Vergleichsauswahl geleert.');
      if (firstId) document.querySelector(`[data-bfc-compare-toggle="${firstId}"]`)?.focus({ preventScroll: true });
    } else if (button.hasAttribute('data-bfc-compare-add')) {
      const id = addSelect.value;
      if (id) toggle(id);
      if (picker.hidden) dialog.querySelector('[data-bfc-compare-close]').focus();
      else addSelect.focus();
    } else if (button.hasAttribute('data-bfc-compare-remove')) {
      toggle(button.dataset.bfcCompareRemove, true);
      addSelect.focus();
    }
  });

  dialog.addEventListener('change', event => {
    if (event.target === addSelect) {
      dialog.querySelector('[data-bfc-compare-add]').disabled = !addSelect.value;
      return;
    }
    const select = event.target.closest('[data-bfc-compare-variant]');
    if (!select) return;
    const item = selection.find(entry => entry.id === select.dataset.bfcCompareVariant);
    const recipe = item && catalog.get(item.id);
    const variant = recipe?.variants.find(entry => entry.id === select.value);
    if (!variant) return;
    item.variant = variant.id;
    save();
    dialog.querySelector(`[data-bfc-compare-price="${item.id}"]`).replaceWith(priceCell(item));
    dialog.querySelector(`[data-bfc-compare-product-link="${item.id}"]`).href = productURL(recipe, variant);
    announce(`${recipe.title}, ${variant.title}: ${variant.price}${variant.unitPrice ? `, ${variant.unitPrice}` : ''}.`);
  });
  dialog.addEventListener('click', event => {
    if (event.target !== dialog) return;
    const bounds = dialog.getBoundingClientRect();
    if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
  });
  dialog.addEventListener('close', () => {
    document.body.style.overflow = previousOverflow;
    if (opener?.isConnected && !opener.closest('[hidden]')) opener.focus({ preventScroll: true });
  });
  // Native filtering and the theme editor can insert fresh cards without navigating.
  new MutationObserver(records => {
    if (records.some(record => [...record.addedNodes].some(node => node.nodeType === 1 && (node.matches?.('[data-bfc-compare-toggle]') || node.querySelector?.('[data-bfc-compare-toggle]'))))) syncButtons();
  }).observe(document.body, { childList: true, subtree: true });
  syncTray();
})();
